import type { MergeApiError } from '../api/MergeApiError';

// CONC-4 (CLD-2969): This is the single decision point for structural
// blocking. Any changes to the blocking rule belong here.
//
// ROW_SET_MISMATCH blocks from any route. NO_LEGAL_DECISION is a transition
// arm for an API that predates ROW_SET_MISMATCH: it blocks only on the diff,
// where it used to be the sole signal. Remove it once the API ships everywhere.
export function detectStructuralBlock(
  error: MergeApiError | null,
  fromDiff = true
): {
  blocked: boolean;
  message: string;
} {
  const blocked =
    error?.code === 'ROW_SET_MISMATCH' ||
    (fromDiff && error?.code === 'NO_LEGAL_DECISION');
  return {
    blocked,
    message: blocked ? error.message : '',
  };
}
